document.addEventListener('DOMContentLoaded', () => {
  initCurtain();
  initMobileMenu();
  initCatNavToggle();
  initGallery();
  initExploreRail();
  initScrollReveal();
  initDeptTileTilt();
  initPageTransition();
  initWishlist();
  initCartDrawer();
  initSizeGuide();
});

function initSizeGuide() {
  const openBtn = document.querySelector('[data-size-guide-open]');
  const modal = document.querySelector('[data-size-guide-modal]');
  if (!openBtn || !modal) return;

  const closeBtns = modal.querySelectorAll('[data-size-guide-close]');

  function open() {
    modal.hidden = false;
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.body.classList.add('pl-no-scroll');
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('pl-no-scroll');
    setTimeout(() => { modal.hidden = true; }, 250);
  }

  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });
  closeBtns.forEach((btn) => btn.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
}

function initCurtain() {
  const curtain = document.querySelector('[data-curtain]');
  if (!curtain) return;

  let alreadySeen = false;
  try {
    alreadySeen = sessionStorage.getItem('pl-curtain-seen') === '1';
  } catch (e) {}

  if (alreadySeen || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    curtain.remove();
    return;
  }

  try {
    sessionStorage.setItem('pl-curtain-seen', '1');
  } catch (e) {}

  setTimeout(() => {
    curtain.classList.add('is-hidden');
    curtain.addEventListener('transitionend', () => curtain.remove(), { once: true });
  }, 400);
}

function initMobileMenu() {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
}

function initCatNavToggle() {
  const toggle = document.querySelector('[data-catnav-toggle]');
  const list = document.querySelector('[data-catnav-list]');
  if (!toggle || !list) return;

  toggle.addEventListener('click', () => {
    const isOpen = list.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
}

function initDeptTileTilt() {
  const tiles = document.querySelectorAll('[data-tilt-tile]');
  if (!tiles.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  const maxTilt = 10;

  tiles.forEach((tile) => {
    const glare = tile.querySelector('[data-tilt-glare]');

    tile.addEventListener('mouseenter', () => {
      tile.classList.remove('is-settling');
    });

    tile.addEventListener('mousemove', (e) => {
      const rect = tile.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width;
      const py = (e.clientY - rect.top) / rect.height;
      const rotateY = (px - 0.5) * maxTilt * 2;
      const rotateX = (0.5 - py) * maxTilt * 2;
      tile.style.transform = `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.04)`;
      if (glare) {
        glare.style.setProperty('--glare-x', `${px * 100}%`);
        glare.style.setProperty('--glare-y', `${py * 100}%`);
      }
    });

    tile.addEventListener('mouseleave', () => {
      tile.classList.add('is-settling');
      tile.style.transform = 'perspective(900px) rotateX(0) rotateY(0) scale(1)';
    });
  });
}

function initPageTransition() {
  const overlay = document.querySelector('[data-page-transition]');
  if (!overlay) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.querySelectorAll('[data-tilt-tile]').forEach((link) => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (!href || link.target === '_blank' || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      overlay.classList.add('is-active');
      setTimeout(() => {
        window.location.href = href;
      }, 400);
    });
  });
}

function initGallery() {
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const wrapper = gallery.closest('.product-detail__media');
    if (!wrapper) return;
    const thumbs = wrapper.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.galleryThumb;

        gallery.querySelectorAll('[data-gallery-image]').forEach((img) => {
          img.classList.toggle('is-active', img.dataset.galleryImage === index);
        });
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  });
}

function initExploreRail() {
  document.querySelectorAll('.explore-rail').forEach((rail) => {
    const track = rail.querySelector('[data-rail-track]');
    const prev = rail.querySelector('[data-rail-prev]');
    const next = rail.querySelector('[data-rail-next]');
    if (!track) return;

    const scrollAmount = () => track.clientWidth * 0.7;
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  });
}

const WISHLIST_KEY = 'pl_wishlist';

function getWishlist() {
  try {
    const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY));
    return Array.isArray(raw) ? raw : [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(handles) {
  try {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
  } catch (e) {}
}

function initWishlist() {
  const toggles = document.querySelectorAll('[data-wishlist-toggle]');
  const openBtn = document.querySelector('[data-wishlist-open]');
  const drawer = document.querySelector('[data-wishlist-drawer]');
  const closeBtn = document.querySelector('[data-wishlist-close]');
  const backdrop = document.querySelector('[data-wishlist-backdrop]');
  const countEl = document.querySelector('[data-wishlist-count]');
  const listEl = document.querySelector('[data-wishlist-list]');
  const emptyEl = document.querySelector('[data-wishlist-empty]');

  function updateCount() {
    const ids = getWishlist();
    if (countEl) {
      countEl.textContent = String(ids.length);
      countEl.hidden = ids.length === 0;
    }
  }

  function syncToggleStates() {
    const ids = getWishlist();
    toggles.forEach((btn) => {
      const handle = btn.dataset.productHandle;
      const active = ids.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  toggles.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      let ids = getWishlist();
      if (ids.indexOf(handle) !== -1) {
        ids = ids.filter((h) => h !== handle);
      } else {
        ids.push(handle);
      }
      saveWishlist(ids);
      syncToggleStates();
      updateCount();
    });
  });

  updateCount();
  syncToggleStates();

  if (!openBtn || !drawer) return;

  function imageWithWidth(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function renderDrawer() {
    const ids = getWishlist();
    if (!listEl) return;
    listEl.innerHTML = '';

    if (ids.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    Promise.all(
      ids.map((handle) =>
        fetch('/products/' + handle + '.js')
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    ).then((products) => {
      listEl.innerHTML = '';
      let anyRendered = false;

      products.forEach((product, i) => {
        if (!product) return;
        anyRendered = true;
        const handle = ids[i];
        const img = product.featured_image || (product.images && product.images[0]) || '';
        const price = (product.price / 100).toFixed(2).replace('.', ',') + ' zł';

        const item = document.createElement('div');
        item.className = 'pl-wishlist-item';

        const media = document.createElement('a');
        media.href = '/products/' + handle;
        media.className = 'pl-wishlist-item__media';
        if (img) {
          const imgEl = document.createElement('img');
          imgEl.src = imageWithWidth(img, 200);
          imgEl.alt = product.title;
          imgEl.loading = 'lazy';
          media.appendChild(imgEl);
        }

        const body = document.createElement('div');
        body.className = 'pl-wishlist-item__body';
        const titleLink = document.createElement('a');
        titleLink.href = '/products/' + handle;
        titleLink.className = 'pl-wishlist-item__title';
        titleLink.textContent = product.title;
        const priceSpan = document.createElement('span');
        priceSpan.className = 'pl-wishlist-item__price';
        priceSpan.textContent = price;
        body.appendChild(titleLink);
        body.appendChild(priceSpan);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'pl-wishlist-item__remove';
        removeBtn.setAttribute('aria-label', 'Usuń z ulubionych');
        removeBtn.innerHTML = '&times;';
        removeBtn.addEventListener('click', () => {
          const remaining = getWishlist().filter((h) => h !== handle);
          saveWishlist(remaining);
          syncToggleStates();
          updateCount();
          renderDrawer();
        });

        item.appendChild(media);
        item.appendChild(body);
        item.appendChild(removeBtn);
        listEl.appendChild(item);
      });

      if (!anyRendered && emptyEl) emptyEl.hidden = false;
    });
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    document.body.classList.add('pl-no-scroll');
    renderDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('pl-no-scroll');
  }

  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  });
  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  backdrop && backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
}

function imageWithWidth(url, width) {
  if (!url) return url;
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
}

function initCartDrawer() {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const openBtns = document.querySelectorAll('[data-cart-open]');
  const closeBtns = drawer.querySelectorAll('[data-cart-close]');
  const backdrop = drawer.querySelector('[data-cart-backdrop]');
  const listEl = drawer.querySelector('[data-cart-list]');
  const emptyEl = drawer.querySelector('[data-cart-empty]');
  const footerEl = drawer.querySelector('[data-cart-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const countEls = document.querySelectorAll('[data-cart-count]');

  function updateCount(count) {
    countEls.forEach((el) => {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (!listEl) return;
    listEl.innerHTML = '';

    if (cart.items.length === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;

    cart.items.forEach((item, index) => {
      const line = index + 1;
      const el = document.createElement('div');
      el.className = 'pl-cart-item';

      const media = document.createElement('a');
      media.href = item.url;
      media.className = 'pl-cart-item__media';
      if (item.image) {
        const img = document.createElement('img');
        img.src = imageWithWidth(item.image, 160);
        img.alt = item.product_title || item.title;
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const body = document.createElement('div');
      body.className = 'pl-cart-item__body';

      const titleLink = document.createElement('a');
      titleLink.href = item.url;
      titleLink.className = 'pl-cart-item__title';
      titleLink.textContent = item.product_title || item.title;
      body.appendChild(titleLink);

      if (item.variant_title) {
        const variant = document.createElement('span');
        variant.className = 'pl-cart-item__variant';
        variant.textContent = item.variant_title;
        body.appendChild(variant);
      }

      const row = document.createElement('div');
      row.className = 'pl-cart-item__row';

      const qty = document.createElement('div');
      qty.className = 'pl-cart-item__qty';
      const minusBtn = document.createElement('button');
      minusBtn.type = 'button';
      minusBtn.textContent = '−';
      minusBtn.setAttribute('aria-label', 'Zmniejsz ilość');
      minusBtn.addEventListener('click', () => changeLine(line, item.quantity - 1));
      const qtyVal = document.createElement('span');
      qtyVal.textContent = String(item.quantity);
      const plusBtn = document.createElement('button');
      plusBtn.type = 'button';
      plusBtn.textContent = '+';
      plusBtn.setAttribute('aria-label', 'Zwiększ ilość');
      plusBtn.addEventListener('click', () => changeLine(line, item.quantity + 1));
      qty.appendChild(minusBtn);
      qty.appendChild(qtyVal);
      qty.appendChild(plusBtn);

      const price = document.createElement('span');
      price.className = 'pl-cart-item__price';
      price.textContent = formatMoney(item.final_line_price);

      row.appendChild(qty);
      row.appendChild(price);
      body.appendChild(row);

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'pl-cart-item__remove';
      removeBtn.textContent = 'Usuń';
      removeBtn.addEventListener('click', () => changeLine(line, 0));
      body.appendChild(removeBtn);

      el.appendChild(media);
      el.appendChild(body);
      listEl.appendChild(el);
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then((r) => r.json());
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: Math.max(0, quantity) }),
    })
      .then((r) => r.json())
      .then(renderCart)
      .catch(() => {});
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    document.body.classList.add('pl-no-scroll');
    fetchCart().then(renderCart).catch(() => {});
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('pl-no-scroll');
  }

  openBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });
  closeBtns.forEach((btn) => btn.addEventListener('click', closeDrawer));
  backdrop && backdrop.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Dodawanie…';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
          if (!ok) {
            alert(data.description || 'Nie udało się dodać produktu do koszyka.');
            return;
          }
          fetchCart().then((cart) => {
            renderCart(cart);
            openDrawer();
          });
        })
        .catch(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
          form.submit();
        });
    });
  });
}

function initScrollReveal() {
  const items = document.querySelectorAll('[data-reveal]');
  if (!items.length) return;

  if (!('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  items.forEach((el) => io.observe(el));
}
